import React, { useEffect } from "react"
import DocumentMeta from "react-document-meta"
import { useNavigate, Link } from "react-router-dom"
import Header from "../components/Header"

const Privacy: React.FC = () => {
	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
	}, [])

	return (
		<DocumentMeta>
			<div>
				<div className="light">
					<Header type="logo" />
					<div className="text-back  mx-auto  py-8 ">
						<div className=" bg-[url(/src/bgimages/form-bg.png)] bg-cover py-8 mb-6">
							<h2 className="h2 mb-8 mt-12 text-center font-Alpro text-2xl text-white lg:mt-24">Datenschutz</h2>
						</div>
						<div className="container max-w-[800px] mx-auto">
							<p className="mb-4 text-blue" >
								(1) Verantwortlicher für die Erhebung, Verarbeitung und Nutzung der Daten ist Danone Deutschland GmbH, Am Hauptbahnhof 18, 60329 Frankfurt am Main, Deutschland. Die Kontaktdaten des Datenschutzbeauftragten von Danone Deutschland lauten:
								Für DE: M. Linder (ebDSB DANONE) c/o intersoft consulting services AG, Beim Strohhause 17, 20097 Hamburg, <a href="mailto:MLinder@intersoft-consulting.de" target="_blank" className="underline">MLinder@intersoft-consulting.de</a>
							</p>
							<p className="mb-4 text-blue" >
								(2) Zweck der Datenverarbeitung<br />

								Der Schutz Ihrer Daten ist uns wichtig. Danone respektiert die Privatsphäre aller
								Personen, die an der Cashback-Aktion teilnehmen. Die Verarbeitung Ihrer
								personenbezogenen Daten erfolgt zum Zweck der Durchführung der Cashback
								Aktion, insbesondere zur Prüfung der Teilnahmevoraussetzungen, zur Validierung
								der eingereichten Kaufbelege sowie zur Abwicklung der Rückzahlung (Cashback).
								Darüber hinaus dient die Verarbeitung der Optimierung unserer
								Marketingmaßnahmen. Rechtsgrundlage für die Verarbeitung ist Art. 6 Abs. 1 lit.
								b) DSGVO (Vertragserfüllung) sowie Art. 6 Abs. 1 lit. f) DSGVO (berechtigtes
								Interesse an der Verbesserung unserer Marketingaktivitäten). Die Bereitstellung
								der personenbezogenen Daten ist für die Teilnahme an der Cashback-Aktion
								erforderlich. Eine Nichtbereitstellung kann zur Folge haben, dass eine Teilnahme
								nicht möglich ist. Im Rahmen der Aktion werden eingereichte Kaufbelege mit Hilfe
								eines KI-gestützten Systems verarbeitet. Dieses System extrahiert strukturierte
								Informationen wie Produktname, Kaufdatum, Preis und Händler, um die
								Teilnahmevoraussetzungen (z. B. Aktionsprodukt, Aktionszeitraum) automatisiert
								zu prüfen und die Teilnahme zu validieren. Darüber hinaus können die aus den
								Belegen extrahierten Daten in anonymisierter oder pseudonymisierter Form zur
								internen Analyse und zur Erstellung statistischer Auswertungen verwendet werden
								(z. B. mit Tools wie Microsoft Power Automate). Mit der Teilnahme willigen die
								Teilnehmer in die Erhebung, Verarbeitung und Nutzung der von ihnen
								angegebenen personenbezogenen Daten bei Danone zur Abwicklung der Gratis
								Testen Aktion ein. Die Daten der Teilnehmer werden bis zum 15.06.2026
								vollständig gelöscht, sofern keine entgegenstehenden gesetzlichen
								Aufbewahrungsfristen bestehen.
							</p>
							<p className="mb-4 text-blue" >
								(3) Datensicherheit; keine Weitergabe an Dritte <br />

								Die personenbezogenen Daten der Teilnehmer werden bei Danone mit geeigneten
								technischen und organisatorischen Maßnahmen gesichert, um die Daten gegen
								zufällige oder vorsätzliche Manipulationen, teilweisen oder vollständigen Verlust,
								Zerstörung oder gegen den unbefugten Zugriff Dritter zu schützen. Die
								Sicherheitsmaßnahmen von Danone werden entsprechend der technologischen
								Entwicklung fortlaufend verbessert. Zugriff auf die Daten hat nur Danone. Eine
								Weitergabe an Dritte erfolgt nicht.
							</p>
							<p className="mb-4 text-blue" >
								(4) Widerruf der Einwilligung<br />

								Die Teilnehmer können ihre Einwilligung zur Erhebung, Verarbeitung und Nutzung
								ihrer personenbezogenen Daten bei Danone jederzeit für die Zukunft widerrufen.
								Der Widerruf ist zu richten an: Im Fall des Widerrufs ist die Teilnahme an der Gratis
								Testen Aktion nicht mehr möglich.
							</p>
							<p className="mb-4 text-blue" >
								(5) Weitere Rechte der Teilnehmer<br />

								Teilnehmer haben außerdem das Recht:<br />

								- gemäß Art. 15 DSGVO Auskunft über die verarbeiteten personenbezogenen
								Daten zu verlangen. Insbesondere können sie Auskunft über die
								Verarbeitungszwecke, die Kategorie der personenbezogenen Daten, die
								Kategorien von Empfängern, gegenüber denen ihre Daten offengelegt wurden
								oder werden, die geplante Speicherdauer, das Bestehen eines Rechts auf
								Berichtigung, Löschung, Einschränkung der Verarbeitung oder Widerspruch, das
								Bestehen eines Beschwerderechts, die Herkunft ihrer Daten, sofern diese nicht bei
								Danone erhoben wurden, sowie über das Bestehen einer automatisierten
								Entscheidungsfindung einschließlich Profiling und ggf. aussagekräftigen
								Informationen zu deren Einzelheiten verlangen;
							</p>
							<p className="mb-4 text-blue" >
								- gemäß Art. 16 DSGVO unverzüglich die Berichtigung unrichtiger oder
								Vervollständigung ihrer gespeicherten personenbezogenen Daten zu verlangen;
							</p>
							<p className="mb-4 text-blue" >
								- gemäß Art. 17 DSGVO die Löschung der gespeicherten personenbezogenen
								Daten zu verlangen, soweit nicht die Verarbeitung zur Ausübung des Rechts auf
								freie Meinungsäußerung und Information, zur Erfüllung einer rechtlichen
								Verpflichtung, aus Gründen des öffentlichen Interesses oder zur Geltendmachung,
								Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist;
							</p>
							<p className="mb-4 text-blue" >
								- gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung ihrer
								personenbezogenen Daten zu verlangen, soweit die Richtigkeit der Daten vom
								Teilnehmer bestritten wird, die Verarbeitung unrechtmäßig ist, die Teilnehmer
								aber die Löschung ablehnen;
							</p>
							<p className="mb-4 text-blue" >
								- gemäß Art. 20 DSGVO ihre personenbezogenen Daten, die sie uns bereitgestellt
								haben, in einem strukturierten, gängigen und maschinenlesebaren Format zu
								erhalten oder die Übermittlung an einen anderen Verantwortlichen zu verlangen.
								Das vorgenannte Verlangen auf Auskunft, Berichtigung, Vervollständigung,
								Löschung, Einschränkung der Verarbeitung, Erhalt der Daten bzw. Übermittlung
								an einen anderen Verantwortlichen sind zu richten an:  <a href="mailto:info@gratistesten.alpro.com " target="_blank" className="underline">info@gratistesten.alpro.com</a>.
							</p>
							<p className="mb-4 text-blue" >
								(6) Beschwerderecht<br />

								Falls Teilnehmer der Ansicht sein sollten, dass Danone bei der Verarbeitung der
								personenbezogenen Daten gegen datenschutzrechtliche Bestimmungen verstößt,
								können sie sich bei einer Aufsichtsbehörde beschweren. Zuständig sind die
								Aufsichtsbehörden in dem Mitgliedstaat des Aufenthaltsorts oder Arbeitsplatzes
								der Teilnehmer oder die Aufsichtsbehörden am Ort des mutmaßlichen Verstoßes.
							</p>
						</div>
					</div>
					<div className=" py-10 pt-5 text-center text-xl text-blue">
						<Link
							to="/"
							className="mb-6 mt-12 block w-[100%] bg-blue p-4 font-Alpro text-[24px] font-bold uppercase tracking-wider text-white drop-shadow-md sm:w-[auto] md:text-[32px] trackind-wider rounded-full border-[3px] border-white lg:inline-block lg:py-2 lg:px-6"
						>
							Zurück
						</Link>
					</div>
				</div>
			</div>
		</DocumentMeta >
	)
}
export default Privacy
